<div *ngIf="config" class="rich">
  <div *ngIf="content" [froalaView]="content | multiLang | shortCode" [ngClass]="class">
  </div>
</div>
